/* src/app/views/template/components/edit-template-menu/edit-template-shelf-talker-menu/edit-template-shelf-talker-brands-menu/edit-template-shelf-talker-brands-menu/edit-template-shelf-talker-brands-menu.component.scss */
/*# sourceMappingURL=edit-template-shelf-talker-brands-menu.component.css.map */
